import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-four-mini-cubes-icon',
  standalone: true,
  templateUrl: './four-mini-cubes-icon.component.html',
  styleUrls: ['./four-mini-cubes-icon.component.scss']
})
export class FourMiniCubesIconComponent {
  @Input() width: number | string = 20;
  @Input() height: number | string = 20;
}
